 export default function loadMapData(name) {
     return new Promise((resolve, reject) => {
         switch (name) {
             case "china":
                 require(['./china.json'], resolve)
                 break;
             case "beijingcounty":
                 require(['./../common/inMapOverlay/BeiJingCounty-Polygon/data.json'], (data) => {
                     resolve({
                         "type": "FeatureCollection",
                         "features": data
                     });
                 });
                 break;
             case "jingjinjiCitys":
                 require(['./../common/inMapOverlay/jingjinjiCitys-Polygon/data.json'], (data) => {
                     resolve({
                         "type": "FeatureCollection",
                         "features": data
                     });
                 });
 
             case "jingjinjiCounty":
                 require(['./../common/inMapOverlay/jingjinjiCounty-Polygon/data.json'], (data) => {
                    
                     resolve({
                         "type": "FeatureCollection",
                         "features": data
                     });
                 });
                 break;

         }

     });

 }